export const TelecomOfferParametersGeneration = (offerData, selectedProviderId, country) => {
  const options = new URLSearchParams()
  options.append('lang', country)

  const parametersToExclude = ['created_at', 'updated_at', 'organisation', 'is_complete', 'usable_for_netting_process']
  const countryToIncludeAttributes = ['it']

  for (const [name, value] of Object.entries(offerData)) {
    if (countryToIncludeAttributes.includes(country) && name.startsWith('attr_')) {
      options.append(name, value)
      continue
    }
    if (value !== undefined && value !== null && value.toString().length > 0 && !parametersToExclude.includes(name)) {
      options.append(name, value)
    }
  }

  options.append('id', offerData.id ?? '')
  options.append('organisation_id', selectedProviderId ?? '')
  options.append('product_type', offerData.product_type ?? '')
  options.append('name', offerData.name ?? '')
  options.append('zoho_id', offerData.zoho_id ?? '')
  options.append('active', offerData.active ?? '')
  options.append('description', offerData.description ?? '')

  return options
}
